module.exports = __webpack_public_path__ + "assets/b7e8b1b6bad6759e346c46116fc46afa.mp3";